export function replaceTooltip(html) {
  if (html) {
    const PATTERN = /\\tooltip\[(.*)\]\{(.*)\}\\/s;
    const REPLACE_TEXT = '<div class="WysiwygField__tooltip">$1<div class="WysiwygField__tooltiptext"><div class="WysiwygField__corner"></div>$2</div></div>';
    return html.replace(PATTERN, REPLACE_TEXT);
  }
  return '';
}


// Replace all media urls to redirect to direct download links
export function replaceMediaToDownloadLinks(html) {
  const re = /(\/media.*?")/g;
  const matches = [];
  let m;
  // Collect matches
  do {
    m = re.exec(html);
    if (m) matches.push(m[1]);
  } while (m);

  // Remove duplicates to prevent incorrect replacing
  let uniqueMatches = [...new Set(matches)];

  // Replace the data
  for (let index = 0; index < uniqueMatches.length; index++) {
    let match = uniqueMatches[index];

    match = match.substring(0, match.length - 1);
    html = html.replaceAll(match, `${match.replace('/document', '')}/download`);
  }
  return html;
}
